import IconeAjuda from '@/global/components/IconeAjuda'
import { Grid } from '@mui/material'
import { FormField, FormFieldCheckbox, FormFile } from 'global/components/Form'
import { SelectEmpresa, SelectFuncionario } from 'global/components/Selects'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

export default function FormNovaFaltaCadastrada() {
    const { watch, setValue } = useFormContext()
    const isInjustificada = watch('isInjustificada')
    const isReadOnly = watch('isReadOnly')

    useEffect(() => {
        if (isInjustificada) setValue('justificativa', '')
    }, [isInjustificada])

    return (
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <SelectEmpresa width="100%" />
            </Grid>
            <Grid item xs={6}>
                <SelectFuncionario width="100%" />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="data"
                    label="Data"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    required
                />
            </Grid>
            <Grid item xs={4}>
                <FormField
                    name="tempo"
                    label="Horas de falta"
                    type="time"
                    InputProps={{
                        endAdornment: (
                            <IconeAjuda>
                                Caso informado, esse tempo será considerado como
                                a falta que você cadastrou e o resto do tempo de
                                falta do dia será considerado como o outro tipo
                                de falta.
                                <br />
                                Deixe em branco para que o dia todo seja
                                considerado como o tipo de falta que você está
                                cadastrando.
                                <br />
                                <br />
                                Exemplo: Se o funcionário tiver 5 horas de falta
                                em um dia e você informar 4 horas justificadas,
                                o sistema irá considerar 4 horas como falta
                                justificada e 1 hora como falta injustificada.
                            </IconeAjuda>
                        ),
                    }}
                />
            </Grid>
            <Grid item xs={4}>
                <div className="flex h-14 items-center">
                    <FormFieldCheckbox
                        label="FALTA INJUSTIFICADA"
                        name="isInjustificada"
                    />
                </div>
            </Grid>
            <Grid item xs={12}>
                <FormField
                    label="Justificativa"
                    name="justificativa"
                    required
                    multiline
                    rows={3}
                    max={190}
                    disabled={isInjustificada}
                />
            </Grid>
            <Grid item xs={12}>
                <FormFile
                    name="fileUrl"
                    disabled={isInjustificada || isReadOnly}
                />
            </Grid>
        </Grid>
    )
}
